import { FC } from "react";
import { CountryInput } from "../../../../../components/filters/Locations/CountryInput";
import { StateInput } from "../../../../../components/filters/Locations/StateInput";
import { HgIndustryInput } from "../../../../../components/filters/Industries/HgIndustryInput";
import { NaicsInput } from "../../../../../components/filters/Industries/NaicsInput";
import { SicInput } from "../../../../../components/filters/Industries/SicInput";
import { ProductCategoryInput } from "../../../../../components/filters/ProductCategory/ProductCategoryInput";
import { ProductAttributesInput } from "../../../../../components/filters/ProductAttributes/ProductAttributesInput";
import { VendorInput } from "../../../../../components/input/VendorInput/VendorInput";
import { CollectionType } from "../../../../../apis/bacchus/collections";
import { ProductFilter } from "../../../../../components/filters/ProductFilter/ProductFilter";
import { HydratedIntentTopicSelector } from "./HydratedIntentTopicSelector";

interface Props {
  collectionType: CollectionType;
  country: string; // If collectionType is state
  selectedItems: string[] | number[];
  onSelect: (items: string[] | number[]) => void;
}

export const ItemSelect: FC<Props> = ({
  collectionType,
  country,
  selectedItems,
  onSelect,
}) => {
  switch (collectionType) {
    case "country":
      return (
        <CountryInput
          isMultiple
          selectedItems={selectedItems as string[]}
          onCountrySelect={onSelect as (value: string[]) => void}
        />
      );

    case "state":
      return (
        <StateInput
          countryAlpha2={country}
          selectedItems={selectedItems as string[]}
          onStateSelect={(_, stateIds) => {
            onSelect(stateIds);
          }}
        />
      );

    case "industry":
      return (
        <HgIndustryInput
          selectedItems={selectedItems as number[]}
          onIndustriesSelect={onSelect as (ids: number[]) => void}
        />
      );

    case "naics":
      return (
        <NaicsInput
          selectedItems={selectedItems as string[]}
          onNaicsSelect={onSelect as (ids: string[]) => void}
        />
      );

    case "sic":
      return (
        <SicInput
          selectedItems={selectedItems as string[]}
          onSicSelect={onSelect as (ids: string[]) => void}
        />
      );

    case "product":
      return (
        <ProductFilter
          selectedProductIds={selectedItems as number[]}
          onProductsSelect={({ ids }) => {
            onSelect(ids);
          }}
          uploadProps={{
            dialogTitle: "Import Products",
            titleDescription: "Upload products to the collection",
          }}
          disableCollectionSelect
        />
      );

    case "product_category":
      return (
        <ProductCategoryInput
          selectedItems={selectedItems as string[]}
          onProductCategorySelect={onSelect as (ids: string[]) => void}
        />
      );

    case "product_attribute":
      return (
        <ProductAttributesInput
          selectedItems={selectedItems as string[]}
          onProductAttributesSelect={onSelect as (ids: string[]) => void}
        />
      );

    case "vendor":
      return (
        <VendorInput
          selectedVendorIds={selectedItems as number[]}
          onVendorsSelect={(vendorOptions) => {
            onSelect(vendorOptions.map(({ value }) => parseInt(value)));
          }}
        />
      );

    case "intent":
      return (
        <HydratedIntentTopicSelector
          selectedTopicIds={selectedItems as string[]}
          onSelect={(topicIds) => onSelect(topicIds)}
        />
      );

    default:
      return null;
  }
};
